import { render, staticRenderFns } from "./ProductPriceIndex.vue?vue&type=template&id=0cc1d03b&scoped=true"
import script from "./ProductPriceIndex.vue?vue&type=script&lang=js"
export * from "./ProductPriceIndex.vue?vue&type=script&lang=js"
import style0 from "./ProductPriceIndex.vue?vue&type=style&index=0&id=0cc1d03b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc1d03b",
  null
  
)

export default component.exports